/* istanbul ignore file */
import { Field } from '../services/logic-services/models';

export class FilterFieldGroup {
    fields: Field[] = [];
    projectId?: string;
    projectName?: string;
}
